// reports
const GET_REPORTS_BY_NAME = 'report/searchByName';
const GET_REPORTS_SEARCH_BY_NAME = 'report/getReportsSearchByName';
const GET_METRIC_TYPES = 'report/metricTypes';
const TRANSFER_REPORT_OWNERSHIP = 'report/transferOwnership';

// downloads
const GET_DOWNLOADS = 'download';
const GET_TEXT_DUMPS = 'download/textDumps';
const DOWNLOAD_PDF = 'download/pdf';
const DOWNLOAD_UNDERLYING_PDF = 'download/pdf/underlying';
const DOWNLOAD_DASHBOARD_PDF = 'download/pdf/dashboard';
const DOWNLOAD_DASHBOARD_UNDERLYING_PDF = 'download/pdf/dashboard/underlying';

// dashboards
const GET_DASHBOARDS_BY_NAME = 'dashboardGroup/searchByName';
const GET_DASHBOARD_GROUP = 'dashboardGroup';
const GET_DASHBOARD_REPORTS_RELOADING_DATA = 'dashboardGroup/reportsData';
const SET_DASHBOARD_TABS = 'dashboardGroup/setTabs';
const SAVE_DASHBOARD_GROUP_SETTINGS = 'dashboardGroup/settings';
const TRANSFER_DASHBOARD_OWNERSHIP = 'dashboardGroup/transferOwnership';
const SAVE_DASHBOARD_FILTER_VIEW = 'dashboardGroup/saveFilterView';
const DELETE_DASHBOARD_FILTER_VIEW = 'dashboardGroup/deleteFilterView';

// metadata config
const GET_METADATA = 'metaData/config';
const GET_USER_ROLES = 'metadata/userRoles';
const GET_REPORT_CONFIG = 'metadata/report';

// schedules
const GET_SCHEDULERS = 'schedules/getSchedulesByEntity';

const FAVOURITE_DASHBOARD_GROUP = 'dashboardGroup/updateFavourite';

const SEARCH_EMPLOYEE_BY_EMAIL = 'search/employee';
const SEARCH_CUSTOMER_BY_EMAIL = 'search/customer';
const SEARCH_VENDOR_BY_EMAIL = 'search/vendor';
const SEARCH_COURIER_ACCOUNT_BY_EMAIL = 'search/courierAccount';
const EXPORT_REPORT = 'report/export';
const IMPORT_REPORT = 'report/import';
const EXPORT_DASHBOARD = 'dashboardGroup/exports';
const IMPORT_DASHBOARD = 'dashboardGroup/import';
const GET_IMPORTABLE_DASHBOARDS = 'dashboardGroup/listForImport';
const GET_DASHBOARD_GROUP_TABS = 'dashboardGroup';
const IMPORT_DASHBOARD_TABS = 'dashboardGroup';

const GET_OWNER_DETAILS = 'search/employee/getOwnerDetails';

// data dictionary
const GET_DATA_DICTIONARY_GROUPED = 'dataDictionary/grouped';

// child entity codes
const GET_CHILD_ENTITY_CODES = 'metaData/childEntityCodes';

// calculation metadata
const GET_CALCULATION_METADATA = 'calculation-metadata';

// events
const TRACK_EVENT = 'event/trackEvent';

// catalogue
const GET_CATALOGUE_TYPES = 'catalogue/types';
const GET_CATALOGUE = 'catalogue';

// task types
const GET_TASK_TYPE_LIST = 'taskType';
const GET_TASK_TYPE_BY_ID = 'taskType';

export {
  GET_REPORTS_BY_NAME,
  GET_DOWNLOADS,
  GET_TEXT_DUMPS,
  GET_DASHBOARDS_BY_NAME,
  GET_METADATA,
  GET_SCHEDULERS,
  GET_METRIC_TYPES,
  FAVOURITE_DASHBOARD_GROUP,
  SEARCH_EMPLOYEE_BY_EMAIL,
  SEARCH_CUSTOMER_BY_EMAIL,
  SEARCH_VENDOR_BY_EMAIL,
  SEARCH_COURIER_ACCOUNT_BY_EMAIL,
  GET_REPORT_CONFIG,
  GET_USER_ROLES,
  GET_DASHBOARD_GROUP,
  EXPORT_REPORT,
  EXPORT_DASHBOARD,
  IMPORT_REPORT,
  IMPORT_DASHBOARD,
  GET_IMPORTABLE_DASHBOARDS,
  GET_DASHBOARD_GROUP_TABS,
  IMPORT_DASHBOARD_TABS,
  GET_DASHBOARD_REPORTS_RELOADING_DATA,
  SET_DASHBOARD_TABS,
  SAVE_DASHBOARD_GROUP_SETTINGS,
  GET_REPORTS_SEARCH_BY_NAME,
  TRANSFER_REPORT_OWNERSHIP,
  TRANSFER_DASHBOARD_OWNERSHIP,
  GET_OWNER_DETAILS,
  SAVE_DASHBOARD_FILTER_VIEW,
  DELETE_DASHBOARD_FILTER_VIEW,
  GET_DATA_DICTIONARY_GROUPED,
  GET_CALCULATION_METADATA,
  GET_CATALOGUE_TYPES,
  GET_CATALOGUE,
  GET_TASK_TYPE_LIST,
  GET_TASK_TYPE_BY_ID,
  GET_CHILD_ENTITY_CODES,
  TRACK_EVENT,
  DOWNLOAD_PDF,
  DOWNLOAD_UNDERLYING_PDF,
  DOWNLOAD_DASHBOARD_PDF,
  DOWNLOAD_DASHBOARD_UNDERLYING_PDF,
};
